import { InputHTMLAttributes } from "react";
import { Accordion, Form } from "react-bootstrap";
import { NoData, Spinner } from "@whitespace/whitespace-ui";

interface ActionFilterProps extends InputHTMLAttributes<HTMLInputElement> {
  register: any;
  accordionKey: string;
  actions: string[];
  hasFilterChanged : boolean;
  isUserHistoryFilterDrawerOpen: boolean;
  onSelectionChange: () => void;
}

const ActionFilter : React.FC<ActionFilterProps> = ({
  register, accordionKey, actions, hasFilterChanged, isUserHistoryFilterDrawerOpen, onSelectionChange
} : ActionFilterProps) => {
  const renderActions = () => {
    if (actions && isUserHistoryFilterDrawerOpen) {
      return actions?.map(action => (
        <Form.Check
          {...register("actions")}
          key={`action_${action}`}
          id={`action_${action}`}
          data-testid={`action_${action}`}
          name="actions"
          type="checkbox"
          label={`${action}`}
          value={action}
          className="left-margin-medium"
          onInput={onSelectionChange}
        />
      ));
    }
    return undefined;
  };

  return (
    <>
      <Accordion key={accordionKey} defaultActiveKey={hasFilterChanged ? "accordionActions" : ""}>
        <Accordion.Item eventKey="accordionActions">
          <Accordion.Header>
            Action
            <Spinner className="left-margin-small" animation="grow" visible={false} spinnerText="Loading" variant="info" />
          </Accordion.Header>
          <Accordion.Body>
            <section>
              <Form.Group controlId="actions">
                {renderActions()}
                <NoData visible={actions && actions.length === 0} description="No Actions found." />
              </Form.Group>
            </section>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default ActionFilter;
